import { getAdExamplesSSR } from "@/ssr/ad-examples"
import { axios } from "@/utils/axios-wrapper"
import {
	SSRNotFound,
	SSRTemporaryRedirect,
	wrapSSRAuth,
} from "@/utils/ssr-auth"
import axiosRetry from "axios-retry"
import GalleryAll from "sections/gallery/all-gallery"
import {
	AdExamplesPageProps,
	FilterStateAdExamples,
	MetaLinks,
} from "."

export default function AdExamplesPage(
	props: AdExamplesPageProps,
) {
	return (
		<GalleryAll
			adExamplesJobs={props.jobs}
			initialFiltersAdExamples={props.initial}
			pageTitle={props.pageTitle}
			metaLinks={props.metaLinks}
			pageNumber={props.pageNumber}
			initialPage="ad-examples"
		/>
	)
}

export const getServerSideProps = wrapSSRAuth(
	async (context, userInfo) => {
		const id = context.params?.slug
		let page = Number(context.query.page)

		if (typeof id !== "string") {
			throw new SSRNotFound()
		}

		if (userInfo) {
			throw new SSRTemporaryRedirect(
				"/discover?filter=ad-examples&q=" +
					encodeURIComponent(id),
			)
		}

		if (isNaN(page) || page < 1) {
			page = 1
		}

		const prevNumber = page > 1 ? page - 1 : null

		const metaLinks: MetaLinks = {
			current: `/ad-examples/${id}?page=` + page,
			next: `/ad-examples/${id}?page=` + (page + 1),
			prev: prevNumber
				? `/ad-examples/${id}?page=` + prevNumber
				: null,
		}

		const applyFilters = {
			searchQuery: id.replaceAll("-", " "),
			aspect: null,
		} as const

		const payload: FilterStateAdExamples = {
			...applyFilters,
			applyFilters,
		}

		axiosRetry(axios, { retries: 3 })

		const [jobs] = await Promise.all([
			getAdExamplesSSR(payload, page),
		])

		const number =
			jobs.type === "searched" ? jobs.total : null
		const text = id
			.replaceAll("-", " ")
			.replace(/\b\w/g, (match) => match.toUpperCase())
		const title = number ? number + " " + text : text

		const props: AdExamplesPageProps = {
			jobs,
			initial: payload,
			pageTitle: title,
			metaLinks,
			pageNumber: page,
		}

		return props
	},
	[],
)
